module.exports = "<div class=modal-header> <h3 class=modal-title>API Key Authentication</h3> </div> <div class=modal-body> <form role=form class=form-horizontal ng-submit=authenticate(apiKey)> <div class=form-group> <label class=col-sm-3>API Key</label> <div class=col-sm-9> <input type=text class=form-control placeholder=key ng-model=apiKey> </div> </div> </form> </div> <div class=modal-footer> <button class=\"btn btn-warning\" ng-click=cancel()>Cancel</button> <button class=\"btn btn-primary\" ng-click=authenticate(apiKey) ng-disabled=!apiKey>Authenticate</button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./templates/auth/api-key.html
 ** module id = 412
 ** module chunks = 0
 **/